window.sq = window.sq || {};

// window.sq.onData = function (data) {
//   if (data.query.textFacetFilters.tags_size_tag?.length == 0) return data;

//   // Only show products and variants where option1 matches textFacetFilter
//   data.results = data.results.filter(x => {
//     // Only keep the product if at least one variant matches the condition
//     x.variants = x.variants.filter(variant => {
//       // Check if variant option1 matches the textFacetFilter tag
//       return variant.option1.includes(data.query.textFacetFilters.tags_size_tag[0]) && variant.inventory_quantity > 0;
//     });

//     // Only include the product if it has at least one matching variant
//     return x.variants.length > 0;
//   });

//   return data;
// };
window.sq.onData = function (data) {
  // Defensive guards
  const sizeFilters = data?.query?.textFacetFilters?.tags_size_tag;
  if (!Array.isArray(sizeFilters) || sizeFilters.length === 0) return data;

  // If you only care about the first selected size
  const selected = String(sizeFilters[0]).toLowerCase();

  // Safety: handle missing results/variants/option1/inventory
  const results = Array.isArray(data?.results) ? data.results : [];

  const filtered = results
    .map(prod => {
      const variants = Array.isArray(prod?.variants) ? prod.variants : [];

      const keptVars = variants.filter(v => {
        const opt1 = v?.option1 != null ? String(v.option1).toLowerCase() : "";
        const qty = Number.isFinite(v?.inventory_quantity) ? v.inventory_quantity : 0;

        return opt1.includes(selected) && qty > 0;
      });

      // Return a shallow copy with filtered variants
      return { ...prod, variants: keptVars };
    })
    // Keep only products that still have variants
    .filter(prod => prod.variants.length > 0);

  // Write back and return
  data.results = filtered;
  return data;
};

// (function (XHR) {
//   "use strict";

//   var open = XHR.prototype.open;
//   var send = XHR.prototype.send;

//   XHR.prototype.open = function (method, url, async, user, pass) {
//     this._url = url;
//     open.call(this, method, url, async, user, pass);
//   };

//   XHR.prototype.send = function (data) {
//     var self = this;
//     var url = this._url;

//     if (
//       url &&
//       url.toLowerCase() ===
//         "https://eux5f5n7yl9l96m2smrqvgbg.fast.sparq.ai/v2".toLowerCase()
//     ) {
//       const body = JSON.parse(data);
//       const filterVals = body.textFacetFilters.tags_size_tag;

//       if (filterVals?.length > 0) {
//         const queryCondition = filterVals
//           .map((x) => ` tags_size_tag="${x}" `)
//           .join("AND"); //filterVals.map((x) => "'" + x + "'").join(" + ");

//         body.filter = body.filter + " AND variants.inventory_quantity > 0" + " AND " + queryCondition;
//       }

//       data = JSON.stringify(body);
//     }
//     send.call(this, data);
//   };
// })(XMLHttpRequest);




